/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const strings = {
  actionDone: 'Operation Completed Successfully',
  actionFailed: 'The operation could not be completed, please try again',
  title: 'Users List',
  subtitle: 'Select a user to update his profile data',

  tabs: {
    ACTIVE: 'Active',
    SUSPENDED: 'Suspended',
    WAITING_ACTIVATION_APPROVAL: 'Waiting Activation',
    IDEAL_USERS: 'Inactive Users',
  },

  columns: {
    index: 'ID',
    userName: 'Username',
    name: 'Full name',
    email: 'Email',
    groups: 'Group',
    status: 'Status',
  },

  actions: {
    add: 'Add',
    createLocalUser: 'Create User (Local)',
    importFromExcelLocal: 'Import From Excel (Local)',
    importFromExcelAd: 'Import From Excel (Active Directory)',
    update: 'Update',
    syncDataSource: 'Fetch and synchronize data',
    importResigned: 'Update the data of resigned employees from an Excel',
    resetPasswords: 'Reset Passwords For Users',
    filter: 'Search',
  },

  clone: {
    title: 'Pull users from the integration source',
    hint: 'Add the users found in the integration source to the users list',
    source: 'Integration source',
    sourcePlaceholder: 'Choose the integration source',
    note: 'Only new users are added; no existing user is deleted or changed.',
    submit: 'Pull users',
    running: 'Please wait...',
  },

  fetch: {
    action: 'Fetch from the integration source',
    hint: 'Type the username, then fetch their details from the integration source to fill the fields',
    running: 'Fetching...',
    usernameRequired: 'Type the username first',
    filled: "The user's details were fetched",
    notFound: 'That user was not found in the integration source',
  },

  filter: {
    groupLabel: 'Departments:',
    groupPlaceholder: 'Group',
    typeLabel: 'Type:',
    typePlaceholder: 'User type',
    adminsOnly: 'Admins Only',
    usersOnly: 'Users Only',
    cancel: 'Cancel',
    submit: 'Search',
  },

  row: {
    edit: 'Edit User Data',
    status: 'Account status',
    delete: 'Delete user',
    deleteConfirm: (name) =>
      `${name}'s account will be permanently deleted, with its roles and sign-in history. This cannot be undone.`,
  },

  footer: {
    deleteInactive: 'Delete',
  },

  create: {
    title: 'Create User (Local)',
    hint: 'This feature is used to register a local user without integration with Active Directory',
    username: 'Username',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    email: 'Email',
    submit: 'Create User',
    errors: {
      usernameRequired: 'User Name is required.',
      passwordRequired: 'Password is required.',
      passwordFormat:
        'The password must be 6-64 characters and include at least one digit and one of the symbols !@#$%^&*',
      confirmRequired: 'Confirm Password is required.',
      confirmMismatch: 'The Password and Confirmation Password must match.',
      emailRequired: 'E-mail is required.',
      emailFormat: 'Please enter a valid e-mail address.',
    },
  },

  importModal: {
    intro: 'Please upload a file in Excel (.xlsx) or CSV (.csv) format',
    columnsIntro: 'The file must contain the following columns',
    mandatory: 'Mandatory',
    optional: 'Optional',
    notesTitle: 'Important Notes',
    notes:
      'The first row in the file must contain the column names, exactly matching the names and order shown in the table',
    template: 'View Template',
    save: 'Save',
    fileError: 'Excel or CSV file',
  },

  importTypes: {
    UsersByEmail: {
      title: 'Import From Excel (Local)',
      hint: 'This feature is used to register multiple local users through an Excel file without integration with Active Directory',
      columns: [
        { name: 'Email', required: true },
        { name: 'FullName', required: false },
        { name: 'Department', required: false },
      ],
    },
    ActiveDirectoryUsers: {
      title: 'Import From Excel (Active Directory)',
      hint: 'This feature is used to register multiple users through an Excel file, provided that the username exists in Active Directory. It is intended for organizations where the Active Directory is outdated or synchronization cannot be enabled',
      columns: [
        { name: 'Username', required: true },
        { name: 'Email', required: true },
        { name: 'Department Name', required: true },
        { name: 'Full Name', required: true },
      ],
    },
    ResignedUsers: {
      title: 'Update the data of resigned employees from an Excel',
      hint: 'This feature is used to manually update resignations (used only if synchronization is not enabled and resignations detection from the integration source is not activated)',
      columns: [
        { name: 'Username', required: true },
        { name: 'Resignation Date (d/M/yyyy)', required: true },
      ],
    },
    ResetUsersPasswords: {
      title: 'Reset Passwords For Users',
      hint: 'This can be used to reset passwords for existing users',
      columns: [{ name: 'Username', required: true }],
    },
  },

  edit: {
    title: 'Edit User Data',
    tabs: {
      profile: 'Edit User Data',
      permissions: 'Privileges',
      password: 'Change Password',
    },
    nameAr: 'Arabic Name',
    nameEn: 'English Name',
    group: 'Group',
    gender: 'Gender',
    selectGender: 'Select Gender',
    male: 'Male',
    female: 'Female',
    email: 'Email',
    phone: 'Telephone',
    mobile: 'Mobile',
    employeeId: 'Employee Id',
    save: 'Save',
    required: 'Field required',
    lengthError: 'Text must be with in 3 to 200 letters.',
    selectAllRoles: 'Select All',
    updateRoles: 'Update',
    roleUser: 'Normal User',
    roleAdmin: 'Admin',
    autoPasswordHint: 'Change the password automatically and send it to the user\'s email',
    autoPasswordButton: 'Change user password',
    manualPasswordHint: 'Set the password manually',
    newPassword: 'Password',
    confirmNewPassword: 'Confirm Password',
    changePassword: 'Change Password',
    passwordMismatch: 'Password and confirm password not matched',

    noPasswordChange: 'Cannot change password',
    noPasswordChangeReason: 'Cannot change password when login is by Active directory',
  },

  status: {
    tabs: {
      approve: 'Account Status',
      expiry: 'Account Expiry',
      locked: 'User Temporary Locking',
      resigned: 'Resignation',
    },
    approved: 'Is Approved',
    notes: 'Notes',
    update: 'Update',
    save: 'Save',
    expiryLabel: 'Account Expiry',
    lockoutLabel: 'Lockout End Date',
    lockoutHint: 'Leave empty to unlock the account',
    unlockNow: 'Unlock now',
    fetchedResignation: 'Fetched Resignation Date By Sync Operation',
    none: 'None',
    resignationLabel: 'Resignation Date',
    resignationHint: 'Leave empty to cancel the resignation',
  },

  deleteInactiveConfirm: 'Are you sure you want to delete the inactive users?',
  selectAll: 'Select All',
  close: 'Close',
}
